import * as yup from 'yup';
import { linkSchema } from '../schemas';
import { schema as slideoutMenuLinkSchema } from './slideout_menu_link';
import { schema as slideDownMenuLinkSchema } from './slide_down_menu_link';
import { schema as referAFriendButtonSchema } from './refer_a_friend_button';

export const schema = yup
  .object({
    heading: yup.string(),
    links: yup.array(
      yup.lazy(item => {
        if (item.component === 'slideout_menu_link')
          return slideoutMenuLinkSchema;
        if (item.component === 'slide_down_menu_link')
          return slideDownMenuLinkSchema;
        if (item.component === 'refer_a_friend_button')
          return referAFriendButtonSchema;
        return linkSchema;
      }),
    ),
    linkFontColor: yup.string(),
    headingFontColor: yup.string(),
    component: yup.string(),
  })
  .transform(value => {
    return {
      heading: value.heading,
      links: value.links,
      component: value.component || 'nav_link_group',
      linkFontColor: value.link_font_color || undefined,
      headingFontColor: value.heading_font_color || undefined,
    };
  });
